// extracted by mini-css-extract-plugin
export default {"melodyVideo":"CJ-z","isFullWidth":"DJ-z","landingPageVideo":"EJ-z","play":"FJ-z","iframeVideo":"GJ-z","playHidden":"HJ-z","fullwidth":"IJ-z"};